/* eslint-disable import/no-default-export */
import BaseEngine from './base';

export default class FetchEngine extends BaseEngine {
  tryRequest: BaseEngine['tryRequest'] = async (
    request: Request,
  ): Promise<ApiRawResponse> => {
    let response: Response;

    try {
      response = await window.fetch(request);

      const contentType = response.headers.get('content-type');

      return {
        statusCode: response.status,
        contentType,
        body: await response.text(),
      };
    } catch (ex) {
      // Failed because of a network issue, so we try to retry
      return this.NETWORK_ERROR;
    }
  };
}



// WEBPACK FOOTER //
// ./app/gamma/src/api/trello-client-js/engines/fetch.ts